export default __webpack_public_path__ + "static/favicon-934276269c860263c4eb848e327807f7.ico";